export default "__VITE_ASSET__DdmC1839__"